export const initialState = {
  userLoggedIn: localStorage?.getItem("islogin") === "true" ? true : false,
  isLoading: false,
  sysConfig: {},
  isRefetchNotificationCount: false,
  userInfo: localStorage?.getItem("user_info")
    ? JSON.parse(localStorage.getItem("user_info"))
    : {},
};

function reducer(state, action) {
  // console.log(action);
  switch (action.type) {
    case "SET_LOGIN_STATUS":
      localStorage.setItem("islogin", action.status);

      return {
        ...state,
        userLoggedIn: action.status,
      };

    case "SET_USER_INFO":
      localStorage.setItem("user_info", JSON.stringify(action.data));

      return {
        ...state,
        userInfo: action.data,
      };
    case "REFETCH_NOTIFICATION_COUNT":
      return {
        ...state,
        isRefetchNotificationCount: action.status,
      };
    case "SET_SYS_CONFIG":
      return {
        ...state,
        sysConfig: action.data,
      };

    case "SET_LOADING":
      if (action.statu) {
        window.scrollTo(0, 0);
        document.body.style.overflow = "hidden";
      } else {
        window.scrollTo(0, 0);

        document.body.style.overflow = "unset";
      }
      return {
        ...state,
        isLoading: action.status,
      };

    default:
      return state;
  }
}

export default reducer;
